import type { Chat, FilterQuery } from '@ztechapps/common.contract'
import { ChatStatusEnum } from '@ztechapps/common.contract'
import { buildConversationSearch } from './buildConversationSearch'

export const buildConversationFilter = (input: string, filter?: FilterQuery<Chat>): FilterQuery<Chat> => ({
  ...buildConversationSearch(input),
  // Excluded by default — a caller that already sets its own `status` filter overrides this.
  status: { $ne: ChatStatusEnum.Cancelled },
  ...filter,
})
